import { render } from "./game-tab.vue?vue&type=template&id=46f156c0&scoped=true"
import script from "./game-tab.vue?vue&type=script&lang=js"
export * from "./game-tab.vue?vue&type=script&lang=js"

import "./game-tab.vue?vue&type=style&index=0&id=46f156c0&scoped=true&lang=css"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f156c0"]])

export default __exports__